import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If set to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, this specifies that Google Pay can only be used for payments if the user's Google Pay wallet already contains allowed payment methods.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      